// extracted by mini-css-extract-plugin
module.exports = {"container":"SquadNotSelected_container__2k-L4","iconColor":"SquadNotSelected_iconColor__2GVk9","bold":"SquadNotSelected_bold__Rrzif","light":"SquadNotSelected_light__2SmHz"};